<template>
	<div class="flex w-full space-x-sm">
		<span class="sr-only">{{ tg("loading") }}</span>

		<v-placeholder
			aria-hidden="true"
			class="relative flex items-center justify-center overflow-hidden rounded-2xs p-2"
			:class="{
				'size-28 bg-gray-50 before:via-gray-100': inModal,
				'size-32 bg-gray-50 before:via-gray-100': !inModal,
			}"
		>
			<v-placeholder
				class="absolute inset-0 h-20 rounded-2xs bg-gray-50 before:via-gray-100"
			></v-placeholder>

			<div
				class="flex h-20 w-full items-center justify-center rounded-2xs bg-gray-50 before:via-gray-100 sm:w-96"
			>
				<svg
					class="z-50 size-8 text-gray-200"
					aria-hidden="true"
					xmlns="http://www.w3.org/2000/svg"
					fill="currentColor"
					viewBox="0 0 20 18"
				>
					<path
						d="M18 0H2a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h16a2 2 0 0 0 2-2V2a2 2 0 0 0-2-2Zm-5.5
                        4a1.5 1.5 0 1 1 0 3 1.5 1.5 0 0 1 0-3Zm4.376 10.481A1 1 0 0 1 16 15H4a1 1 0
                        0 1-.895-1.447l3.5-7A1 1 0 0 1 7.468 6a.965.965 0 0 1
                        .9.5l2.775 4.757 1.546-1.887a1 1 0 0 1 1.618.1l2.541 4a1 1 0 0 1 .028 1.011Z"
					/>
				</svg>
			</div>
		</v-placeholder>

		<div aria-hidden="true" class="flex-1">
			<div class="flex items-center justify-between">
				<div class="group">
					<v-placeholder
						class="mb-4 h-2.5 w-48 rounded-2xs bg-gray-50 before:via-gray-100"
					></v-placeholder>

					<v-placeholder
						class="mb-4 h-2.5 w-48 rounded-2xs bg-gray-50 before:via-gray-100"
					></v-placeholder>
				</div>
			</div>

			<div class="flex flex-row items-center space-x-4">
				<div class="flex items-baseline space-x-2">
					<div class="flex flex-row items-center space-x-sm">
						<v-placeholder
							class="mb-4 h-md w-24 rounded-2xs bg-gray-50 before:via-gray-100"
						></v-placeholder>

						<v-placeholder
							class="mb-4 h-2.5 w-12 rounded-2xs bg-gray-50 before:via-gray-100"
						></v-placeholder>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script setup lang="ts">
defineProps<{
	inModal?: boolean;
}>();

const {t: tg} = useI18n({useScope: "global"});
</script>
